import React from 'react';
import { Trophy, Target, Heart } from 'lucide-react';
import './About.css';

const About = () => {
  return (
    <section id="clube" className="about section-padding">
      <div className="container">
        <div className="about-header animate-in">
          <span className="about-subtitle">A Nossa Identidade</span>
          <h2 className="about-title">Sobre o Clube</h2>
          <div className="about-header-line"></div>
          <p className="about-description">
            O Clube Desportivo Da Póvoa é uma instituição desportiva com raízes profundas na comunidade local,
            dedicada à promoção do desporto e formação de atletas de elite.
          </p>
        </div>

        <div className="features-grid">
          <div className="feature-card glass-card animate-in" style={{ '--delay': '0.1s' }}>
            <div className="icon-wrapper">
              <Trophy className="feature-icon" />
              <div className="icon-bg-glow"></div>
            </div>
            <h3>Excelência</h3>
            <div className="card-divider"></div>
            <p>Comprometidos com a formação de atletas de alto nível e resultados desportivos que orgulham a nossa cidade.</p>
          </div>

          <div className="feature-card glass-card animate-in" style={{ '--delay': '0.2s' }}>
            <div className="icon-wrapper">
              <Target className="feature-icon" />
              <div className="icon-bg-glow"></div>
            </div>
            <h3>Formação</h3>
            <div className="card-divider"></div>
            <p>Dedicados ao desenvolvimento integral de jovens talentos, incutindo valores, disciplina e espírito de equipa.</p>
          </div>

          <div className="feature-card glass-card animate-in" style={{ '--delay': '0.3s' }}>
            <div className="icon-wrapper">
              <Heart className="feature-icon" />
              <div className="icon-bg-glow"></div>
            </div>
            <h3>Paixão</h3>
            <div className="card-divider"></div>
            <p>Movidos pela herança histórica e pelo orgulho inabalável de representar as cores da Póvoa em cada competição.</p>
          </div>
        </div>
      </div>
      
      {/* Decorative elements for premium feel */}
      <div className="about-bg-decoration decoration-1"></div>
      <div className="about-bg-decoration decoration-2"></div>
    </section>
  );
};

export default About;